// extracted by mini-css-extract-plugin
export default {"room":"Create_room__6SowW","error":"Create_error__tqbqR"};